<template>
<div class="flag-content">
  <el-tooltip
      class="box-item"
      effect="dark"
      :content="content"
      placement="top"
      :disabled="!content"
  >
    <span >{{content ||'-'}}</span>
  </el-tooltip>
  <el-tooltip
      class="box-item"
      effect="dark"
      :content="tip"
      placement="top"
      :disabled="!showTip"
  >
    <img v-if="showTip" src="@/assets/black_flag.png">
  </el-tooltip>
</div>
</template>

<script>
export default {
  name: "flag",
  props: {
    content:{
      type:String,
      default:'',
    },
    tip:{
      type:String,
    },
    showTip:{
      type:[Boolean,Number],
      default:true
    }
  }
}
</script>

<style scoped lang="scss">
.flag-content{
  display: flex;
  align-items: center;
  justify-content: center;
  span{
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: fit-content;
  }
  img{
    width: 62px;
    height: 16px;
    margin-left: 10px;
  }
}
</style>